import { Route } from '@/app/router'

const Company = () => import('./index.vue')

export default new Route('/companies/:id', Company).as('Dashboard:Company').permissions(['VIEW_COMPANIES'])
